import { menuAnatomy as parts } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers
} from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

export const menu = {
  baseStyle: {
    button: {},
    list: {
      borderRadius: '10px',
      p: '10px'
    },
    item: {
      p: '10px',
      borderRadius: '13px',
      color: '#0A0D14',
      fontSize: '14px',
      fontWeight: 'medium',
      lineHeight: '142.857%',
      letterSpacing: '-0.084px',
      _hover: {
        bgColor: '#F6F8FA'
      }
    },
    groupTitle: {},
    icon: {},
    command: {},
    divider: {}
  },
  
};

export default {menu};